import { Player as Lottie } from '@lottiefiles/react-lottie-player';
import { Accordion, AccordionDetails, AccordionSummary, AppBar, Backdrop, Box, Button, Card, Checkbox, CircularProgress, colors, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fade, Grid, IconButton, InputBase, LinearProgress, List, ListItem, ListItemIcon, ListItemText, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Theme, Typography } from '@material-ui/core';
import { ArrowBack, CheckCircle, CloudDownload, CloudUpload, ExpandMore, Repeat, Search } from '@material-ui/icons';
import { Pagination } from '@material-ui/lab';
import axios, { CancelTokenSource } from 'axios';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useHistory } from 'react-router-dom';
import loadingAnimation from '../../assets/animations/loading.json';
import FileUpload from '../../components/FileUpload';
import TableRowCollapse from '../../components/TableRowCollapse';
import Page from '../../containers/Page/Page';
import { useAuth } from '../../hooks/auth';
import { useLoading } from '../../hooks/loading';
import { usePermissions } from '../../hooks/permissions';
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface IConfiguracoes {
    id: string;
    upk_base: string;
    usd_ksb_base: string;
    usd_cpp_base: string;
    usd_compra_base: string;
    euro_compra_base: string;
    data_compra_base: string;
    usd_venda_base: string;
    euro_venda_base: string;
    data_venda_base: string;
    fator_base: string;
    fator_base2: string;
    fator_base3: string;
    fator_base4: string;
    fator_base5: string;
}

interface IImportacao {
    file: string;
    processando: number;
    erros: string;
    created_at: string;
}

interface IModelo {
    id: string;
    nome: string;
}

interface IModeloData {
    data: IModelo[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function Configuracoes() {

    //Hooks
    const history = useHistory();
    const classes = useStyles();
    const permissions = usePermissions();
    const { data } = useAuth();

    //Loading
    const { isLoading, startLoading, stopLoading } = useLoading();

    //Alert
    const { enqueueSnackbar: alert } = useSnackbar();

    //States
    const [error, setError] = React.useState<string>('');
    const [configuracoes, setConfiguracoes] = React.useState<IConfiguracoes>({} as IConfiguracoes);
    const [file, setFile] = React.useState<File>();
    const [importDialog, setImportDialog] = React.useState<boolean>(false);
    const [importacoes, setImportacoes] = React.useState<IImportacao[]>([]);
    const [importacoesDialog, setImportacoesDialog] = React.useState<boolean>(false);
    const [importKSBDialog, setImportKSBDialog] = React.useState<boolean>(false);
    const [importacoesKSB, setImportacoesKSB] = React.useState<IImportacao[]>([]);
    const [importacoesKSBDialog, setImportacoesKSBDialog] = React.useState<boolean>(false);
    const [importCPPDialog, setImportCPPDialog] = React.useState<boolean>(false);
    const [importacoesCPP, setImportacoesCPP] = React.useState<IImportacao[]>([]);
    const [importacoesCPPDialog, setImportacoesCPPDialog] = React.useState<boolean>(false);
    const [importVariantesDialog, setImportVariantesDialog] = React.useState<boolean>(false);
    const [importacoesVariantes, setImportacoesVariantes] = React.useState<IImportacao[]>([]);
    const [importacoesVariantesDialog, setImportacoesVariantesDialog] = React.useState<boolean>(false);
    const [importGruposDialog, setImportGruposDialog] = React.useState<boolean>(false);
    const [importacoesGrupos, setImportacoesGrupos] = React.useState<IImportacao[]>([]);
    const [importacoesGruposDialog, setImportacoesGruposDialog] = React.useState<boolean>(false);
    const [importSegmentosDialog, setImportSegmentosDialog] = React.useState<boolean>(false);
    const [importacoesSegmentos, setImportacoesSegmentos] = React.useState<IImportacao[]>([]);
    const [importacoesSegmentosDialog, setImportacoesSegmentosDialog] = React.useState<boolean>(false);
    const [importDescontosClienteDialog, setImportDescontosClienteDialog] = React.useState<boolean>(false);
    const [importacoesDescontosCliente, setImportacoesDescontosCliente] = React.useState<IImportacao[]>([]);
    const [importacoesDescontosClienteDialog, setImportacoesDescontosClienteDialog] = React.useState<boolean>(false);
    const [importDescontosInfDialog, setImportDescontosInfDialog] = React.useState<boolean>(false);
    const [importacoesDescontosInf, setImportacoesDescontosInf] = React.useState<IImportacao[]>([]);
    const [importacoesDescontosInfDialog, setImportacoesDescontosInfDialog] = React.useState<boolean>(false);
    const [importPermissoesDialog, setImportPermissoesDialog] = React.useState<boolean>(false);
    const [importacoesPermissoes, setImportacoesPermissoes] = React.useState<IImportacao[]>([]);
    const [importacoesPermissoesDialog, setImportacoesPermissoesDialog] = React.useState<boolean>(false);
    const [importImpostosDialog, setImportImpostosDialog] = React.useState<boolean>(false);
    const [importacoesImpostos, setImportacoesImpostos] = React.useState<IImportacao[]>([]);
    const [importacoesImpostosDialog, setImportacoesImpostosDialog] = React.useState<boolean>(false);
    const [modelos, setModelos] = React.useState<IModelo[]>([]);
    const [modeloDialog, setModeloDialog] = React.useState<boolean>(false);
    const [modeloSearch, setModeloSearch] = React.useState<string>('');
    const [modeloData, setModeloData] = React.useState<IModeloData>();
    const [expanded, setExpanded] = React.useState<string>('');

    //Refs
    const cancelTokenSource = React.useRef<CancelTokenSource | null>(null);

    //Effects
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchImportacoes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchModelos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar as configurações.
     * @returns void
     */
    async function handleFetch() {
        startLoading('main');
        try {
            const response = await api.get(`configs`);
            setConfiguracoes(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        } finally {
            stopLoading('main');
        }
    }

    /**
     * Carregar modelos do modal de exportação.
     * @param page 
     */
    async function handleFetchModelos(page: number = 1) {
        startLoading('modelos');
        try {
            const response = await api.get(`modelos?search=${modeloSearch}&page=${page}&ativa=1`);
            setModeloData(response.data.object);
        } catch (error) {
            Helpers.error(error, alert);
        }
        stopLoading('modelos');
    }


    /**
     * Salvar as configurações.
     * @returns void
     */
    async function handleBlur() {
        try {
            await api.put(`configs/${configuracoes.id}`, configuracoes);
        } catch (error: any) {
            Helpers.error(error, alert);
        }
    }

    /**
     * Importar modelos, bombas e acessórios.
     * @returns void
     */
    async function handleImport() {
        if (file) {
            setImportDialog(false);
            startLoading('import');
            try {
                const form = new FormData();
                form.append('geral', file);
                const response = await api.post('modelos/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('import');
            }
        }
    }

    /**
     * Exportar modelos, bombas e acessórios.
     * @returns void
     */
    async function handleExport() {
        startLoading('export');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('modelos/exportar', {}, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Modelos_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('export');
        }
    }

    /**
     * Cancela a exportação.
     * @returns void
     */
    function handleExportCancel() {
        if (cancelTokenSource.current) {
            cancelTokenSource.current.cancel();
            cancelTokenSource.current = null;
        }
    }

    /**
     * Carregar as importações.
     * @returns void
     */
    async function handleFetchImportacoes() {
        startLoading('importacoes');
        try {
            const response = await api.get('configs/imports');
            setImportacoes(response.data.import.geral);
            setImportacoesKSB(response.data.import.preco);
            setImportacoesCPP(response.data.import.cpp);
            setImportacoesVariantes(response.data.import.variantes);
            setImportacoesGrupos(response.data.import.grupos);
            setImportacoesSegmentos(response.data.import.segmentos);
            setImportacoesDescontosInf(response.data.import.inf);
            setImportacoesDescontosCliente(response.data.import.descontos);
            setImportacoesPermissoes(response.data.import.papeis);
            setImportacoesImpostos(response.data.import.impostos);
        } catch (error: any) {
            Helpers.error(error, alert);
        } finally {
            stopLoading('importacoes');
        }
    }

    /**
      * Importar preços KSB.
      * @returns void
      */
    async function handleImportKSB() {
        if (file) {
            setImportKSBDialog(false);
            startLoading('importKSB');
            try {
                const form = new FormData();
                form.append('tabelas', file);
                const response = await api.post('tabelas/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importKSB');
            }
        }
    }

    /**
     * Exportar preços KSB
     * @returns void
     */
    async function handleExportKSB() {
        startLoading('exportKSB');
        setModeloDialog(false);
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('tabelas/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Preços_KSB_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportKSB');
        }
    }

    /**
     * Importar preços CPP.
     * @returns void
     */
    async function handleImportCPP() {
        if (file) {
            setImportCPPDialog(false);
            startLoading('importCPP');
            try {
                const form = new FormData();
                form.append('cpp', file);
                const response = await api.post('cpp/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importCPP');
            }
        }
    }

    /**
     * Exportar preços CPP
     * @returns void
     */
    async function handleExportCPP() {
        startLoading('exportCPP');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('cpp/exportar', {}, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Preços_CPP_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportCPP');
        }
    }

    /**
      * Importar preços Variantes.
      * @returns void
      */
    async function handleImportVariantes() {
        if (file) {
            setImportVariantesDialog(false);
            startLoading('importVariantes');
            try {
                const form = new FormData();
                form.append('variantes', file);
                const response = await api.post('variantes/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importVariantes');
            }
        }
    }

    /**
     * Exportar preços Variantes
     * @returns void
     */
    async function handleExportVariantes() {
        startLoading('exportVariantes');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('variantes/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Preços_Variantes_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportVariantes');
        }
    }

    /**
     * Importar Grupos.
     * @returns void
     */
    async function handleImportGrupos() {
        if (file) {
            setImportGruposDialog(false);
            startLoading('importGrupos');
            try {
                const form = new FormData();
                form.append('grupos', file);
                const response = await api.post('grupos/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importGrupos');
            }
        }
    }

    /**
     * Exportar Grupos.
     * @returns void
     */
    async function handleExportGrupos() {
        startLoading('exportGrupos');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('grupos/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Grupos_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportGrupos');
        }
    }

    /**
     * Importar Segmentos.
     * @returns void
     */
    async function handleImportSegmentos() {
        if (file) {
            setImportSegmentosDialog(false);
            startLoading('importSegmentos');
            try {
                const form = new FormData();
                form.append('segmentos', file);
                const response = await api.post('segmentos/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importSegmentos');
            }
        }
    }

    /**
     * Exportar Segmentos.
     * @returns void
     */
    async function handleExportSegmentos() {
        startLoading('exportSegmentos');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('segmentos/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Segmentos_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportSegmentos');
        }
    }

    /**
     * Importar Descontos de Cliente.
     * @returns void
     */
    async function handleImportDescontosCliente() {
        if (file) {
            setImportDescontosClienteDialog(false);
            startLoading('importDescontosCliente');
            try {
                const form = new FormData();
                form.append('descontos', file);
                const response = await api.post('descontos/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importDescontosCliente');
            }
        }
    }

    /**
     * Exportar Descontos de Cliente.
     * @returns void
     */
    async function handleExportDescontosCliente() {
        startLoading('exportDescontosCliente');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('descontos/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Descontos_Cliente_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportDescontosCliente');
        }
    }

    /**
     * Importar Descontos Inf. Comercial.
     * @returns void
     */
    async function handleImportDescontosInf() {
        if (file) {
            setImportDescontosInfDialog(false);
            startLoading('importDescontosInf');
            try {
                const form = new FormData();
                form.append('inf', file);
                const response = await api.post('infcom/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importDescontosInf');
            }
        }
    }

    /**
     * Exportar Descontos Inf. Comercial.
     * @returns void
     */
    async function handleExportDescontosInf() {
        startLoading('exportDescontosInf');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('infcom/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Descontos_Inf_Comercial_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportDescontosInf');
        }
    }

    /**
    * Importar Permissões.
    * @returns void
    */
    async function handleImportPermissoes() {
        if (file) {
            setImportPermissoesDialog(false);
            startLoading('importPermissoes');
            try {
                const form = new FormData();
                form.append('papeis', file);
                const response = await api.post('usuarios/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importPermissoes');
            }
        }
    }

    /**
     * Exportar Permissões.
     * @returns void
     */
    async function handleExportPermissoes() {
        startLoading('exportPermissoes');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('usuarios/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Permissões_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportPermissoes');
        }
    }

    /**
    * Importar Permissões.
    * @returns void
    */
    async function handleImportImpostos() {
        if (file) {
            setImportImpostosDialog(false);
            startLoading('importImpostos');
            try {
                const form = new FormData();
                form.append('impostos', file);
                const response = await api.post('impostos/save', form);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('importImpostos');
            }
        }
    }

    /**
     * Exportar Permissões.
     * @returns void
     */
    async function handleExportImpostos() {
        startLoading('exportImpostos');
        handleExportCancel();
        cancelTokenSource.current = axios.CancelToken.source();
        try {
            const response = await api.post('impostos/exportar', modelos, {
                headers: { ...api.defaults.headers, 'Content-Type': 'application/octet-stream' },
                responseType: 'blob',
                cancelToken: cancelTokenSource.current.token
            });
            Helpers.download(response, `Impostos_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error: any) {
            if (axios.isCancel(error)) {
                alert('A exportação foi cancelada pelo usuário.', { variant: 'info' });
            } else {
                let file = new Blob([error.response.data], { type: 'application/json' });
                let json = JSON.parse(await file.text());
                alert(json.message, { variant: 'error' });
            }
        } finally {
            handleExportCancel();
            stopLoading('exportImpostos');
        }
    }

    /**
      * Pesquisar com ENTER para modelos.
      * @param event 
      */
    async function handleModelosKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            await handleFetchModelos(1);
        }
    }

    /**
     * Selecionar um modelo.
     * @param modelo 
     */
    function handleModelosSelect(modelo: IModelo) {
        let newModelos = [];
        if (modelos.some(e => e.id === modelo.id)) {
            newModelos = modelos.filter(b => b.id !== modelo.id);
        } else {
            newModelos = modelos.filter(b => b.id !== modelo.id);
            newModelos = [...modelos, modelo];
        }
        setModelos(newModelos);
    }

    return (
        <Page error={error} loading={isLoading('main')}>
            <Page.Title>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <IconButton size="small" color="primary" className={classes.backButton} onClick={() => history.push('/propostas')}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" component="div">
                        Configurações
                    </Typography>
                </Box>
            </Page.Title>
            <Page.Section>
                <Page.Content>
                    <Box p={2}>
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Valores de Conversão
                            </Typography>
                            <Typography variant="caption" component="div">
                                Definição dos valores padrão utilizados para conversão de moedas na proposta
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="upk_base"
                                    name="upk_base"
                                    label="Base UPK"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.upk_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, upk_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="usd_ksb_base"
                                    name="usd_ksb_base"
                                    label="Base USD KSB"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.usd_ksb_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, usd_ksb_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="usd_cpp_base"
                                    name="usd_cpp_base"
                                    label="Base USD CPP"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.usd_cpp_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, usd_cpp_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                        </Grid>
                        <Box mt={2} mb={1}>
                            <Divider></Divider>
                        </Box>
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Valores de Câmbio
                            </Typography>
                            <Typography variant="caption" component="div">
                                Definição dos valores padrão de câmbio utilizados na proposta
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="usd_compra_base"
                                    name="usd_compra_base"
                                    label="Câmbio Compra USD"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.usd_compra_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, usd_compra_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="euro_compra_base"
                                    name="euro_compra_base"
                                    label="Câmbio Compra EUR"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.euro_compra_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, euro_compra_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="data_compra_base"
                                    name="data_compra_base"
                                    label="Câmbio Compra Data"
                                    variant="outlined"
                                    size="small"
                                    type="date"
                                    fullWidth={true}
                                    value={configuracoes.data_compra_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, data_compra_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="usd_venda_base"
                                    name="usd_venda_base"
                                    label="Câmbio Venda USD"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.usd_venda_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, usd_venda_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="euro_venda_base"
                                    name="euro_venda_base"
                                    label="Câmbio Venda EUR"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.euro_venda_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, euro_venda_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="data_venda_base"
                                    name="data_venda_base"
                                    label="Câmbio Venda Data"
                                    variant="outlined"
                                    size="small"
                                    type="date"
                                    fullWidth={true}
                                    value={configuracoes.data_venda_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, data_venda_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                        </Grid>
                        <Box mt={2} mb={1}>
                            <Divider></Divider>
                        </Box>
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Fatores de Cálculo da Base
                            </Typography>
                            <Typography variant="caption" component="div">
                                Fatores que são multiplicados pelo peso da base para o cálculo de valor da mesma
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="fator_base"
                                    name="fator_base"
                                    label="Interno até 200kg"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.fator_base || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, fator_base: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="fator_base2"
                                    name="fator_base2"
                                    label="Interno maior que 200kg"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.fator_base2 || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, fator_base2: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="fator_base3"
                                    name="fator_base3"
                                    label="Externo de 30kg até 250kg"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.fator_base3 || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, fator_base3: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="fator_base4"
                                    name="fator_base4"
                                    label="Externo de 251kg até 1000kg"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.fator_base4 || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, fator_base4: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    id="fator_base5"
                                    name="fator_base5"
                                    label="Externo de 1001kg até 3000kg"
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    value={configuracoes.fator_base5 || ''}
                                    onChange={(event) => setConfiguracoes({ ...configuracoes, fator_base5: event.target.value })}
                                    onBlur={() => handleBlur()}
                                />
                            </Grid>
                        </Grid>
                        <Box mt={2} mb={1}>
                            <Divider></Divider>
                        </Box>
                        <Box mb={2}>
                            <Typography variant="h6" component="div">
                                Importações
                            </Typography>
                            <Typography variant="caption" component="div">
                                Faça importações e exportações dos recursos do sistema
                            </Typography>
                        </Box>
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'modelos'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'modelos' : '')} style={permissions.menu(['modelo.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-modelos"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Modelos, Bombas e Acessórios
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de modelos, bombas e acessórios.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('import')}
                                                fullWidth={true}
                                                startIcon={isLoading('import') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importDialog}
                                                onClick={() => handleImport()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('export')}
                                                fullWidth={true}
                                                startIcon={isLoading('export') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExport()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoes && importacoes.length > 0
                                                                    ? importacoes.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        variant='contained'
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        <Accordion expanded={expanded === 'ksb'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'ksb' : '')} style={permissions.menu(['tabela.export'])}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                id="accordion-ksb"
                            >
                                <Typography className={classes.heading}>
                                    Importação de Preços KSB
                                </Typography>
                                <Typography className={classes.secondaryHeading}>
                                    Faça a importação ou exportação de preços KSB.
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                <Grid className={classes.row} container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="caption" component="div">
                                            A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                            É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isLoading('importKSB')}
                                            fullWidth={true}
                                            startIcon={isLoading('importKSB') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                            onClick={() => setImportKSBDialog(true)}>
                                            Importar
                                        </Button>
                                        <FileUpload
                                            open={importKSBDialog}
                                            onClick={() => handleImportKSB()}
                                            onDrop={(files) => setFile(files[0])}
                                            onClose={() => setImportKSBDialog(false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth={true}
                                            startIcon={<CloudDownload />}
                                            onClick={() => setModeloDialog(true)}>
                                            Exportar
                                        </Button>
                                        <Dialog open={modeloDialog} fullWidth={true} maxWidth="xs">
                                            <AppBar style={{ position: 'relative' }}>
                                                <DialogTitle>Selecionar Modelos</DialogTitle>
                                                <Box mx={3} mb={3}>
                                                    <Paper className={classes.custom}>
                                                        <InputBase
                                                            autoFocus
                                                            disabled={isLoading('modelos')}
                                                            className={classes.input}
                                                            placeholder="Pesquisa"
                                                            onChange={(event) => setModeloSearch(event.target.value)}
                                                            onKeyUp={(event) => handleModelosKeyUp(event)}
                                                            value={modeloSearch}
                                                        />
                                                        <IconButton
                                                            disabled={isLoading('modelos')}
                                                            style={{ padding: 10 }}
                                                            onClick={() => handleFetchModelos()}
                                                        >
                                                            <Search />
                                                        </IconButton>
                                                    </Paper>
                                                    <Box mt={2}>
                                                        <Grid container justifyContent="center">
                                                            <Pagination
                                                                page={modeloData?.current_page || 1}
                                                                count={modeloData?.last_page || 1}
                                                                onChange={(_event, page) => handleFetchModelos(page)}
                                                                color="secondary"
                                                            />
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                                <Fade in={isLoading('modelos')} timeout={500}>
                                                    <LinearProgress color="secondary"></LinearProgress>
                                                </Fade>
                                            </AppBar>
                                            <DialogContent>
                                                <List>
                                                    <ListItem button onClick={() => handleModelosSelect({ id: "0", nome: 'TODOS' })}>
                                                        <ListItemIcon>
                                                            <Checkbox
                                                                edge="start"
                                                                checked={modelos.some(e => e.id === "0")}
                                                                tabIndex={-1}
                                                                disableRipple={true}
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            primary="TODOS"
                                                            secondary="SELECIONAR TODOS OS MODELOS"
                                                        />
                                                    </ListItem>
                                                    {modeloData && modeloData.data.map((modelo, index) => (
                                                        <ListItem button key={index} onClick={() => handleModelosSelect(modelo)}>
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    edge="start"
                                                                    checked={modelos.some(e => e.id === modelo.id) || modelos.some(e => e.id === "0")}
                                                                    tabIndex={-1}
                                                                    disableRipple={true}
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={modelo.nome}
                                                            />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button color="primary" onClick={() => setModeloDialog(false)}>
                                                    Fechar
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleExportKSB()}>
                                                    Exportar
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth={true}
                                            startIcon={<Repeat />}
                                            onClick={() => setImportacoesKSBDialog(true)}>
                                            Sincronizações
                                        </Button>
                                        <Dialog open={importacoesKSBDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesKSBDialog(false)}>
                                            <DialogTitle>Sincronizações</DialogTitle>
                                            <DialogContent>
                                                <TableContainer>
                                                    <Table stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Arquivo</TableCell>
                                                                <TableCell>Data</TableCell>
                                                                <TableCell>Status</TableCell>
                                                                <TableCell>Erros</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {importacoesKSB && importacoesKSB.length > 0
                                                                ? importacoesKSB.slice(0, 5).map((importacao, index) =>
                                                                    <TableRowCollapse
                                                                        key={index}
                                                                        stringData={importacao.erros}
                                                                        title="Erros na Importação:"
                                                                        tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                        <TableCell>{importacao.file}</TableCell>
                                                                        <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                        <TableCell align="center">
                                                                            {(() => {
                                                                                if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                    return (<LinearProgress color="secondary" />);
                                                                                } else if (importacao.processando === 2 && importacao.erros) {
                                                                                    return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                } else {
                                                                                    return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                }
                                                                            })()}
                                                                        </TableCell>
                                                                    </TableRowCollapse>
                                                                ) :
                                                                <TableRow>
                                                                    <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => setImportacoesKSBDialog(false)} color="primary">
                                                    Fechar
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    color="primary"
                                                    disabled={isLoading('importacoes')}
                                                    startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                    onClick={() => handleFetchImportacoes()}>
                                                    Atualizar
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'cpp'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'cpp' : '')} style={permissions.menu(['cpp.export'])}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                id="accordion-cpp"
                            >
                                <Typography className={classes.heading}>
                                    Importação de Preços CPP
                                </Typography>
                                <Typography className={classes.secondaryHeading}>
                                    Faça a importação ou exportação de preços CPP.
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                <Grid className={classes.row} container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="caption" component="div">
                                            A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                            É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isLoading('importCPP')}
                                            fullWidth={true}
                                            startIcon={isLoading('importCPP') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                            onClick={() => setImportCPPDialog(true)}>
                                            Importar
                                        </Button>
                                        <FileUpload
                                            open={importCPPDialog}
                                            onClick={() => handleImportCPP()}
                                            onDrop={(files) => setFile(files[0])}
                                            onClose={() => setImportCPPDialog(false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isLoading('exportCPP')}
                                            fullWidth={true}
                                            startIcon={isLoading('exportCPP') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                            onClick={() => handleExportCPP()}>
                                            Exportar
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth={true}
                                            startIcon={<Repeat />}
                                            onClick={() => setImportacoesCPPDialog(true)}>
                                            Sincronizações
                                        </Button>
                                        <Dialog open={importacoesCPPDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesCPPDialog(false)}>
                                            <DialogTitle>Sincronizações</DialogTitle>
                                            <DialogContent>
                                                <TableContainer>
                                                    <Table stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Arquivo</TableCell>
                                                                <TableCell>Data</TableCell>
                                                                <TableCell>Status</TableCell>
                                                                <TableCell>Erros</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {importacoesCPP && importacoesCPP.length > 0
                                                                ? importacoesCPP.slice(0, 5).map((importacao, index) =>
                                                                    <TableRowCollapse
                                                                        key={index}
                                                                        stringData={importacao.erros}
                                                                        title="Erros na Importação:"
                                                                        tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                        <TableCell>{importacao.file}</TableCell>
                                                                        <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                        <TableCell align="center">
                                                                            {(() => {
                                                                                if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                    return (<LinearProgress color="secondary" />);
                                                                                } else if (importacao.processando === 2 && importacao.erros) {
                                                                                    return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                } else {
                                                                                    return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                }
                                                                            })()}
                                                                        </TableCell>
                                                                    </TableRowCollapse>
                                                                ) :
                                                                <TableRow>
                                                                    <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => setImportacoesCPPDialog(false)} color="primary">
                                                    Fechar
                                                </Button>
                                                <Button
                                                    color="primary"
                                                    variant='contained'
                                                    disabled={isLoading('importacoes')}
                                                    startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                    onClick={() => handleFetchImportacoes()}>
                                                    Atualizar
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion expanded={expanded === 'variantes'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'variantes' : '')} style={permissions.menu(['variante.export'])}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                id="accordion-variantes"
                            >
                                <Typography className={classes.heading}>
                                    Importação de Preços Variantes
                                </Typography>
                                <Typography className={classes.secondaryHeading}>
                                    Faça a importação ou exportação de preços Variantes.
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                <Grid className={classes.row} container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="caption" component="div">
                                            A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                            É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isLoading('importVariantes')}
                                            fullWidth={true}
                                            startIcon={isLoading('importVariantes') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                            onClick={() => setImportVariantesDialog(true)}>
                                            Importar
                                        </Button>
                                        <FileUpload
                                            open={importVariantesDialog}
                                            onClick={() => handleImportVariantes()}
                                            onDrop={(files) => setFile(files[0])}
                                            onClose={() => setImportVariantesDialog(false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth={true}
                                            disabled={isLoading('exportVariantes')}
                                            startIcon={isLoading('exportVariantes') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                            onClick={() => handleExportVariantes()}>
                                            Exportar
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth={true}
                                            startIcon={<Repeat />}
                                            onClick={() => setImportacoesVariantesDialog(true)}>
                                            Sincronizações
                                        </Button>
                                        <Dialog open={importacoesVariantesDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesVariantesDialog(false)}>
                                            <DialogTitle>Sincronizações</DialogTitle>
                                            <DialogContent>
                                                <TableContainer>
                                                    <Table stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Arquivo</TableCell>
                                                                <TableCell>Data</TableCell>
                                                                <TableCell>Status</TableCell>
                                                                <TableCell>Erros</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {importacoesVariantes && importacoesVariantes.length > 0
                                                                ? importacoesVariantes.slice(0, 5).map((importacao, index) =>
                                                                    <TableRowCollapse
                                                                        key={index}
                                                                        stringData={importacao.erros}
                                                                        title="Erros na Importação:"
                                                                        tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                        <TableCell>{importacao.file}</TableCell>
                                                                        <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                        <TableCell align="center">
                                                                            {(() => {
                                                                                if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                    return (<LinearProgress color="secondary" />);
                                                                                } else if (importacao.processando === 2 && importacao.erros) {
                                                                                    return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                } else {
                                                                                    return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                }
                                                                            })()}
                                                                        </TableCell>
                                                                    </TableRowCollapse>
                                                                ) :
                                                                <TableRow>
                                                                    <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                </TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => setImportacoesVariantesDialog(false)} color="primary">
                                                    Fechar
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    color="primary"
                                                    disabled={isLoading('importacoes')}
                                                    startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                    onClick={() => handleFetchImportacoes()}>
                                                    Atualizar
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'grupos'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'grupos' : '')} style={permissions.menu(['grupo.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-grupos"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Grupos
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de grupos.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('importGrupos')}
                                                fullWidth={true}
                                                startIcon={isLoading('importGrupos') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportGruposDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importGruposDialog}
                                                onClick={() => handleImportGrupos()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportGruposDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth={true}
                                                disabled={isLoading('exportGrupos')}
                                                startIcon={isLoading('exportGrupos') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExportGrupos()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesGruposDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesGruposDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesGruposDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoesGrupos && importacoesGrupos.length > 0
                                                                    ? importacoesGrupos.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesGruposDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        color="primary"
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'segmentos'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'segmentos' : '')} style={permissions.menu(['segmento.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-segmentos"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Segmentos
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de segmentos.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('importSegmentos')}
                                                fullWidth={true}
                                                startIcon={isLoading('importSegmentos') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportSegmentosDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importSegmentosDialog}
                                                onClick={() => handleImportSegmentos()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportSegmentosDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth={true}
                                                disabled={isLoading('exportSegmentos')}
                                                startIcon={isLoading('exportSegmentos') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExportSegmentos()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesSegmentosDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesSegmentosDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesSegmentosDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoesSegmentos && importacoesSegmentos.length > 0
                                                                    ? importacoesSegmentos.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesSegmentosDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        color="primary"
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'descontos-cliente'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'descontos-cliente' : '')} style={permissions.menu(['segmento.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-descontos-cliente"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Descontos de Cliente
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de descontos de cliente.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('importDescontosCliente')}
                                                fullWidth={true}
                                                startIcon={isLoading('importDescontosCliente') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportDescontosClienteDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importDescontosClienteDialog}
                                                onClick={() => handleImportDescontosCliente()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportDescontosClienteDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth={true}
                                                disabled={isLoading('exportDescontosCliente')}
                                                startIcon={isLoading('exportDescontosCliente') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExportDescontosCliente()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesDescontosClienteDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesDescontosClienteDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesDescontosClienteDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoesDescontosCliente && importacoesDescontosCliente.length > 0
                                                                    ? importacoesDescontosCliente.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesDescontosClienteDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        color="primary"
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'descontos-inf'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'descontos-inf' : '')} style={permissions.menu(['segmento.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-descontos-inf"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Descontos Inf. Comercial
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de descontos inf. comercial.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('importDescontosInf')}
                                                fullWidth={true}
                                                startIcon={isLoading('importDescontosInf') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportDescontosInfDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importDescontosInfDialog}
                                                onClick={() => handleImportDescontosInf()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportDescontosInfDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth={true}
                                                disabled={isLoading('exportDescontosInf')}
                                                startIcon={isLoading('exportDescontosInf') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExportDescontosInf()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesDescontosInfDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesDescontosInfDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesDescontosInfDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoesDescontosInf && importacoesDescontosInf.length > 0
                                                                    ? importacoesDescontosInf.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesDescontosInfDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        color="primary"
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'permissoes'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'permissoes' : '')} style={permissions.menu(['segmento.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-permissoes"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Permissões
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de permissões.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('importPermissoes')}
                                                fullWidth={true}
                                                startIcon={isLoading('importPermissoes') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportPermissoesDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importPermissoesDialog}
                                                onClick={() => handleImportPermissoes()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportPermissoesDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth={true}
                                                disabled={isLoading('exportPermissoes')}
                                                startIcon={isLoading('exportPermissoes') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExportPermissoes()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesPermissoesDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesPermissoesDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesPermissoesDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoesPermissoes && importacoesPermissoes.length > 0
                                                                    ? importacoesPermissoes.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesPermissoesDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        color="primary"
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {(data.user.papel === 3) &&
                            <Accordion expanded={expanded === 'impostos'} onChange={(event, isExpanded) => setExpanded(isExpanded ? 'impostos' : '')} style={permissions.menu(['imposto.export'])}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    id="accordion-impostos"
                                >
                                    <Typography className={classes.heading}>
                                        Importação de Impostos
                                    </Typography>
                                    <Typography className={classes.secondaryHeading}>
                                        Faça a importação ou exportação de impostos.
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ flex: 1, flexDirection: 'column', width: '100%' }}>
                                    <Grid className={classes.row} container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" component="div">
                                                A importação pode levar um tempo, verifique o status através do botão "Sincronizações".
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography variant="caption" style={{ fontWeight: 'bold', width: '100%' }} component="div" color="error">
                                                É importante não mexer nos campos IDs, eles são usados para identificação. Para adicionar um registro novo, deixe o campo ID vazio.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={isLoading('importImpostos')}
                                                fullWidth={true}
                                                startIcon={isLoading('importImpostos') ? <CircularProgress color="inherit" size={12} /> : <CloudUpload />}
                                                onClick={() => setImportImpostosDialog(true)}>
                                                Importar
                                            </Button>
                                            <FileUpload
                                                open={importImpostosDialog}
                                                onClick={() => handleImportImpostos()}
                                                onDrop={(files) => setFile(files[0])}
                                                onClose={() => setImportImpostosDialog(false)}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                fullWidth={true}
                                                disabled={isLoading('exportImpostos')}
                                                startIcon={isLoading('exportImpostos') ? <CircularProgress color="inherit" size={12} /> : <CloudDownload />}
                                                onClick={() => handleExportImpostos()}>
                                                Exportar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth={true}
                                                startIcon={<Repeat />}
                                                onClick={() => setImportacoesImpostosDialog(true)}>
                                                Sincronizações
                                            </Button>
                                            <Dialog open={importacoesImpostosDialog} fullWidth={true} maxWidth="sm" onClose={() => setImportacoesImpostosDialog(false)}>
                                                <DialogTitle>Sincronizações</DialogTitle>
                                                <DialogContent>
                                                    <TableContainer>
                                                        <Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Arquivo</TableCell>
                                                                    <TableCell>Data</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Erros</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {importacoesImpostos && importacoesImpostos.length > 0
                                                                    ? importacoesImpostos.slice(0, 5).map((importacao, index) =>
                                                                        <TableRowCollapse
                                                                            key={index}
                                                                            stringData={importacao.erros}
                                                                            title="Erros na Importação:"
                                                                            tooltip={importacao.processando === 2 ? 'Não houve erros na importação' : 'Processando...'}>
                                                                            <TableCell>{importacao.file}</TableCell>
                                                                            <TableCell>{moment(importacao.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                                            <TableCell align="center">
                                                                                {(() => {
                                                                                    if (importacao.processando === 0 || importacao.processando === 1) {
                                                                                        return (<LinearProgress color="secondary" />);
                                                                                    } else if (importacao.processando === 2 && importacao.erros) {
                                                                                        return (<CheckCircle htmlColor={colors.yellow[500]} />);
                                                                                    } else {
                                                                                        return (<CheckCircle htmlColor={colors.green[500]} />);
                                                                                    }
                                                                                })()}
                                                                            </TableCell>
                                                                        </TableRowCollapse>
                                                                    ) :
                                                                    <TableRow>
                                                                        <TableCell align="center" colSpan={4}>Nenhuma sincronização em andamento.</TableCell>
                                                                    </TableRow>}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setImportacoesImpostosDialog(false)} color="primary">
                                                        Fechar
                                                    </Button>
                                                    <Button
                                                        variant='contained'
                                                        color="primary"
                                                        disabled={isLoading('importacoes')}
                                                        startIcon={isLoading('importacoes') ? <CircularProgress color="inherit" size={12} /> : null}
                                                        onClick={() => handleFetchImportacoes()}>
                                                        Atualizar
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        }
                        <Backdrop
                            open={isLoading([
                                'export',
                                'exportKSB',
                                'exportCPP',
                                'exportVariantes',
                                'exportGrupos',
                                'exportSegmentos',
                                'exportDescontosCliente',
                                'exportDescontosInf',
                                'exportPermissoes'
                            ])}
                            style={{ zIndex: 9999 }}
                        >
                            <Card elevation={0}>
                                <Lottie
                                    src={loadingAnimation}
                                    autoplay={true}
                                    loop={true}
                                    style={{ height: 250, width: 400 }}
                                />
                                <Box mb={2} textAlign="center">
                                    <Typography color="primary" variant="h6" component="div">
                                        Exportando...
                                    </Typography>
                                    <Typography color="primary" variant="caption" component="div">
                                        A exportação pode levar um tempo, por favor aguarde.
                                    </Typography>
                                </Box>
                                <Box mb={2} textAlign="center">
                                    <Button
                                        style={{ width: 150 }}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => handleExportCancel()}>
                                        Cancelar
                                    </Button>
                                </Box>
                            </Card>
                        </Backdrop>
                    </Box>
                </Page.Content>
            </Page.Section>
        </Page>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginRight: theme.spacing(1),
        },
        custom: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
        },
        row: {
            marginBottom: theme.spacing(1)
        },
        heading: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: 500,
            flexBasis: '33.33%',
            flexShrink: 0,
        },
        secondaryHeading: {
            fontSize: theme.typography.pxToRem(20),
            color: theme.palette.text.secondary,
        },
    })
);

export default Configuracoes;